import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
/**
 * Modal Component
 */
let ModalComponent = class ModalComponent {
    constructor() { }
    ngOnInit() {
    }
    close() {
        this.modal.destroy();
    }
};
ModalComponent = __decorate([
    Component({
        selector: 'ecd-modal',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./modal.component.html")).default
    })
], ModalComponent);
export { ModalComponent };
